import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "../Slide/SlideDeleteValidator.scss";
import "../../css/Popup.scss";
import { keycloak } from "../../services/keycloak";

const LogoutModal = ({register, registerExpiryPopup, decodeToken }) => {
    const [logoutPopup, setLogoutPopup] = useState(false)
    const [logoutTimer, setLogoutTimer] = useState(120);
    const timerInterval = useRef(null);
    const popupTimeout = useRef(null);
    const poupInterval = useRef(null)
    const popupShownRef = useRef(false);
    
    const syncKeycloakState = () => {
        try {
            const token = localStorage.getItem("userToken");
            const refreshToken = localStorage.getItem("refreshToken");
            const idToken = localStorage.getItem("idToken");
            const timeSkew = parseInt(localStorage.getItem("timeSkew")) || 0;

            if (token) {
                keycloak.token = token;
                keycloak.tokenParsed = decodeToken(token);
            }
            if (refreshToken){
                keycloak.refreshToken = refreshToken;
                keycloak.refreshTokenParsed = decodeToken(refreshToken)
            }
            if (idToken) {
                keycloak.idToken = idToken;
                keycloak.idTokenParsed = decodeToken(idToken);
            }
            keycloak.timeSkew = timeSkew;
        } catch (err) {
            console.error("Keycloak sync failed:", err);
        }
    };

    const resetLogoutPopup = async() => {
        registerExpiryPopup(true)
        setLogoutPopup(false)
        setLogoutTimer(0)
        popupShownRef.current = false
        if (popupTimeout.current) clearInterval(popupTimeout.current)
        if (poupInterval.current) clearInterval(poupInterval.current)
        if (timerInterval.current) clearInterval(timerInterval.current);
    }
    
    const scheduleLogoutTimer = () => {
        if (popupTimeout.current) clearInterval(popupTimeout.current);
        
        const popupTime = getTimeLeft();
        
        if(popupTime < -120){
            registerExpiryPopup(true)
            return
        }
        
        if(popupTime >= -120 && popupTime <= 0){
            startExpiryWatcher();
            return
        }
        
        popupTimeout.current = setInterval(() => {
            const timeLeft = getTimeLeft();
            if(timeLeft <= 30) {
                if (popupTimeout.current) clearInterval(popupTimeout.current);
                startExpiryWatcher();
            }
        }, 10000);
    };

    const startExpiryWatcher = () => {
        if (poupInterval.current) clearInterval(poupInterval.current);
        
        poupInterval.current = setInterval(() => {
            const popupTime = getTimeLeft();
            
            if (popupTime <= 0 && !popupShownRef.current) {
                popupShownRef.current = true;

                clearInterval(poupInterval.current);

                setLogoutTimer(120 + popupTime)
                setLogoutPopup(true);
                run120SecTimer(popupTime);
            }
        }, 1000);
    };

    const getTimeLeft = () => {
        const token = localStorage.getItem("userToken")
        const timeSkew = parseInt(localStorage.getItem("timeSkew"))
        const decodedToken = decodeToken(token)
        const exp = decodedToken.exp;
        const now = Math.floor(Date.now() / 1000);
        const timeLeft = exp - now;
        return timeLeft - 120 + timeSkew;
    };
    
    const handleStorage = async(event) => {
        if (event.key === "kc-sync" && event.newValue) {
            // console.log("STORAGE EVENT FIRED", event.key);
            if (timerInterval.current) clearInterval(timerInterval.current);
            if (popupTimeout.current) clearInterval(popupTimeout.current)
            if (poupInterval.current) clearInterval(poupInterval.current)
            setLogoutTimer(120)
            popupShownRef.current = false
            setLogoutPopup(false);
            const kcSync = localStorage.getItem("kc-sync")
            if(kcSync){
                localStorage.removeItem("kc-sync");
            }
            syncKeycloakState()
            scheduleLogoutTimer()
        }
    };
    
    useEffect(()=> {
        register(() => scheduleLogoutTimer)
        window.addEventListener("storage", handleStorage);
        document.addEventListener("visibilitychange", scheduleLogoutTimer);
        
        return () => {
            if (popupTimeout.current) clearInterval(popupTimeout.current)
            if (poupInterval.current) clearInterval(poupInterval.current)
            if (timerInterval.current) clearInterval(timerInterval.current);
            window.removeEventListener("storage", handleStorage)
            document.removeEventListener("visibilitychange", scheduleLogoutTimer);
        };
    }, [])

    const handleLogout = async () => {
        setLogoutPopup(false)
        popupShownRef.current = false
        if (popupTimeout.current) clearInterval(popupTimeout.current)
        if (poupInterval.current) clearInterval(poupInterval.current)
        if (timerInterval.current) clearInterval(timerInterval.current);
        try {
            localStorage.clear();
            await keycloak.logout({
                redirectUri: window.location.origin
            });
        } catch (e) {
            console.error("Logout failed", e);
        }
    };

    const handleContinue = async () => {
        setLogoutPopup(false)
        popupShownRef.current = false
        if (popupTimeout.current) clearInterval(popupTimeout.current)
        if (poupInterval.current) clearInterval(poupInterval.current)
        if (timerInterval.current) clearInterval(timerInterval.current);
        try {
            await keycloak.updateToken(-1);
            localStorage.setItem("kc-sync", Date.now().toString())
            setLogoutTimer(120);
        } catch (e) {
            console.error("Token refresh failed", e);
            // await keycloak.updateToken(0)
            // handleLogout();
        }
    };

    const run120SecTimer = () => {
        timerInterval.current = setInterval(() => {
            const timeLeft = getTimeLeft()
            setLogoutTimer(120 + timeLeft);
        }, 1000);
    };
    
    useEffect(() => {
        if (logoutTimer <= 0) {
            resetLogoutPopup()
        }
    }, [logoutTimer]);

    return (
        <div className="deletePromptParent">
            <Dialog
                open={logoutPopup}
                // onClose={handleLogout}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="deletePrompt confirmation"
                sx={{
                    backdropFilter: "blur(2.4px)",
                }}
            >
                <DialogContent style={{ overflowY: "initial", width: "380px", height: "160px" }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        className="discription"
                    >
                        <div className="popup-head">SESSION TIME OUT</div>
                        <div className="popup-separator"></div>
                        <div className="popup-message"><span style={{ color: "#C50F3C" }}>Your session is about to expire in {logoutTimer} sec.</span> Would you like to continue?</div>
                    </DialogContentText>
                </DialogContent>
                <div className="popupFooter">
                    {/* <div className="popupFooterSeparator"></div> */}
                    <Button
                        className="btn popupFooterGrayedButton"
                        type="button"
                        onClick={handleLogout}
                    >
                        LOG OUT
                    </Button>
                    <Button
                        className="btn popupFooterActiveButton"
                        type="button"
                        onClick={handleContinue}
                    >
                        CONTINUE SESSION
                    </Button>
                </div>
            </Dialog>
        </div>
    );
};

export default LogoutModal;